import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { ref, watch } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Pagination',
    props: {
        page: {}
    },
    emits: [
        'change'
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const pageNumber = ref(1);
        onPageNumberChange();
        watch(() => props.page.number, onPageNumberChange);
        function onPageNumberChange() {
            pageNumber.value = props.page.number + 1;
        }
        function onChange(pageNumber) {
            emit('change', pageNumber - 1);
        }
        return (_ctx, _cache) => {
            const _component_b_pagination = _resolveComponent("b-pagination");
            return (__props.page && __props.page.totalPages > 1)
                ? (_openBlock(), _createBlock(_component_b_pagination, {
                    key: 0,
                    modelValue: pageNumber.value,
                    "onUpdate:modelValue": [
                        _cache[0] || (_cache[0] = ($event) => ((pageNumber).value = $event)),
                        onChange
                    ],
                    "total-rows": __props.page.totalElements,
                    "per-page": __props.page.size,
                    size: "sm"
                }, null, 8, ["modelValue", "total-rows", "per-page"]))
                : _createCommentVNode("", true);
        };
    }
});
